import React, { Component } from 'react';
import Waypoint from 'react-waypoint';
import USMapChart from "./USMapChart";

import dataTotals from './data/56_years_totals.json'
import {Semiotic_Stacked_Area} from "./components/semiotic_stacked_area";
import {Semiotic_Line_Graph} from "./components/semiotic_line_graph";
import EmploymentChart from "./EmploymentChart";
import ScrollyTextBox from "./ScrollyTextBox";

import {waypoints} from "./Waypoints.js"
import EmmissionsChart from "./EmmissionsChart";

// var ReactCSSTransitionGroup = require('react-transition-group'); // ES5 with npm

// Sort of works
// const Fade = function({ children, ...props }) {
//   console.log("#faded key: ", props);
//   return (
//     <CSSTransition
//       {...props}
//       timeout={1000}
//       classNames="fade"
//     >
//       {children}
//     </CSSTransition>);
// };

// <TransitionGroup className='vis-transition-group'>
//    <Fade key={this.state.activeWaypoint.correspondingVis}>
//      {this.renderCurrentVis()}
//    </Fade>
// </TransitionGroup>


class App extends Component {

    constructor(props){
        super(props);

        this.state = {
            activeWaypoint: {correspondingVis: 1},
            chartFixed: false,
            chartAtBottom: false,
            firstRender: true
        }
    }

    handleAllWaypointEnters(props, id){
        this.setState({activeWaypoint: waypoints[id], chartFixed: true});
    }

    handleAllWaypointLeaves(props, id){
        if(props.currentPosition === Waypoint.below && id !== 0) {
            this.setState({activeWaypoint: waypoints[id - 1]})
        }
    }

    handleHeaderWaypointEnter(props) {
        this.setState({chartFixed: false});
    }

    handleHeaderWaypointLeave(props) {
        if(props.currentPosition === Waypoint.above) {
            this.setState({chartFixed: true});
        }
    }

    handleFooterWaypointEnter() {
        this.setState({chartFixed: false, chartAtBottom: true});
    }

    handleFooterWaypointLeave() {
        this.setState({chartFixed: true, chartAtBottom: false});
    }

    renderCurrentVis() {
        if (!this.state.activeWaypoint) return null;

        switch(this.state.activeWaypoint.correspondingVis) {
            case 0:
                return null;
            case 1:
                return (
                  <div className={"vis-area-container stacked " + (this.state.chartFixed ? "fixed" : "")}>
                      <h2>U.S. Electric Power Generation Over Time</h2>
                      <Semiotic_Stacked_Area
                        data={dataTotals}
                        annotations={this.state.activeWaypoint.annotations}
                    />
                  <img src="legend.png" className="legend-stacked-area"/>
                  </div>
                );
            case 2:
                return (
                  <div className={"vis-area-container " + (this.state.chartFixed ? "fixed" : "")}>
                    <EmmissionsChart/>
                  </div>
                );
            case 3:
                return (
                  <div className={"vis-area-container " + (this.state.chartFixed ? "fixed" : "")}>
                    <EmploymentChart
                        annotations={this.state.activeWaypoint.annotations}
                    />
                </div>
                );
            case 4:
                return (
                  <div className={"vis-area-container " + (this.state.chartFixed ? "fixed" : "")} style={{padding:"0px 20px 20px 20px"}}>
                  <div style={{width: "100%", height: "90%", alignContent: "center", display: "flex", flexDirection: "column", justifyContent: "opposite"}}>
                    <USMapChart
                        annotations={this.state.activeWaypoint.annotations}
                        year={new Date(this.state.activeWaypoint.annotations[0].YYYYMM).getFullYear().toString()}
                    />
                    <Semiotic_Line_Graph
                        data={dataTotals}
                        annotations={this.state.activeWaypoint.annotations}
                    />
                </div>
              </div>
                );
            default:
                return null;
        }
    }

    renderScrollyTextBoxes() {
        var i = 0;
        waypoints.forEach((w) => (w.id = i++));
        return waypoints.map(w => {
            return (
                <div key={w.id} className="waypoint-wrapper">
                    <Waypoint
                        onEnter={(waypointProps) => this.handleAllWaypointEnters(waypointProps, w.id)}
                        onLeave={(waypointProps) => this.handleAllWaypointLeaves(waypointProps, w.id)}
                        bottomOffset='300px'
                    >
                        <ScrollyTextBox
                            color={w.textBoxColor}
                            description={w.textBoxDescription}
                            title={w.textBoxTitle}
                            active={this.state.activeWaypoint.id === w.id}
                            href={w.citation}
                            id={w.id}
                        />
                    </Waypoint>
                </div>
            );
        });
    }

    render() {
        return (
            <div className="App">
                <div className="header-page" id="header-page">
                    <div className="title-wrapper">
                        <img src="power-plant2.png" className="header-image"/>
                        <h1>Beautiful, clean coal?</h1>
                        <h2>An interactive visual essay by Ian Banatoski, Derek Feehrer, and Michael Moukarzel</h2>
                    </div>
                </div>
                <Waypoint
                    onEnter={(props) => this.handleHeaderWaypointEnter(props)}
                    onLeave={(props) => this.handleHeaderWaypointLeave(props)}
                >
                    <div className="intro-section">
                        <div className="center">
                            <h1><quote>We have ended the war on American energy, and we have <strong>ended the war on beautiful, clean coal.</strong></quote></h1>
                            <h2><em>~President Trump, State of the Union Address 2018</em></h2>
                    </div>
                        <p>
                            The "war on coal" is a phrase that has been used for years by the coal industry and its
                            advocates to describe a struggle between environmental regulations and coal.
                            But is this battle really as black and white as the term implies? As with most real wars,
                            it is often difficult to identify the antagonists.
                        </p>
                        <p>
                            Furthermore, could coal really be clean?
                            Trump's term as president has reignited interest in these questions once again. In order to
                            understand this story, we'll have to take a trip back through time. Our journey begins over
                            70 years ago in 1954.
                        </p>
                        <div className="center">
                            <p>
                               Scroll down to begin...
                            </p>
                        </div>
                    </div>
                </Waypoint>
                    {this.renderCurrentVis()}
                    <div className="column scrolly-column">
                        {this.renderScrollyTextBoxes()}
                    </div>

                <Waypoint
                    onEnter={() => this.handleFooterWaypointEnter()}
                    onLeave={() => this.handleFooterWaypointLeave()}
                >
                    <div className="conclusion-section">
                        <div className="conclusion-section-paragraph">
                          <p>The war on coal is real, but the situation is a lot more complicated than it might initially appear.
                            Market forces and environmental factors both have a role in this story. The country is continually
                            demanding more and more energy and in not so distant future we will be consuming vastly more energy
                            than we do today. Therefore we should expand, rather than limit, our options for clean low-carbon energy.
                            </p>
                            <p>
                                The past decade shows that natural gas has played a key role in helping decarbonize US power. Natural
                                gas is not by any means a perfect energy source, but it may be the lesser of two evils. If coal truly is dying because cheaper cleaner options are becoming
                                more availble, is it worth it to invest more money into saving an energy source that the market is already
                                phasing out.
                            </p>
                            <div className="center">
                                <p>At the end of the day, it's a matter of perspective.</p>
                            </div>
                        </div>
                        <div className="center">
                            <img src="tree-clouds.png" className="conclusion-image"/>
                        </div>
                        <div className="sources-section">
                            <h1><b>Data Sources:</b></h1>
                              <ul style={{listStyleType:"circle", listStylePosition: "inside"}}>
                                <li><a href={"https://www.eia.gov/electricity/data.php#elecenv"}>Extra EIA Data</a></li>
                                <li><a href={"https://www.eia.gov/totalenergy/data/browser/csv.cfm?tbl=T07.02A"}>1950-2016 Monthly Generation</a></li>
                                <li><a href={"https://www.ipcc.ch/pdf/assessment-report/ar5/wg3/ipcc_wg3_ar5_annex-iii.pdf"}>Emmisions Data</a></li>
                                <li><a href={"https://data.bls.gov/timeseries/CES1021210001"}>Unemployment Data</a></li>
                                <li><a href="http://www.freepik.com">Polygon icons designed by Freepik</a></li>
                              </ul>
                        </div>
                    </div>
                </Waypoint>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js